// src/hooks/products/useGetProduct.js
import { useQuery } from "@tanstack/react-query";
import { getProduct } from "../../api/apiProducts";
import i18next from "i18next";

const useGetProduct = (id) => {
    const { data, error, isLoading } = useQuery({
        queryKey: ["product", id, i18next.language],
        queryFn: () => getProduct(id),
        enabled: !!id,
    });

    return {
        product: data?.data || null,
        error,
        isLoading,
    };
};

export default useGetProduct;
